import {Card, CardActionArea, CardContent, CardMedia} from "@mui/material"
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder"
import React from "react"
import { formatUrl } from "../../helpers/functions"

function CardNews({noticia, tensoblog, loading, tensoblogClass, titleSearch}) {
  const {title} = noticia ? noticia : ""

  const SkeletonLoaderCardNews = () => {
    return (
      <Card sx={{ marginBottom: 3 }} className={`${tensoblog ? "card_blog" : ""} item`}>
        <CardContent className="cards-style">
          <div>
            <div className="card-news-loader--cover skeleton"></div>
          <article className="title-card-noticia">
            <h2 id="title" className="skeleton"></h2>
            {/* <span>{formatearFecha(noticia.creation_date)}</span> */}
          </article>
          <article className="texto-slider-loader">
            <p id="about" className="card-news-loader--about skeleton"></p>
          </article>
          </div>
          <article>
            <p id="about" className="skeleton"></p>
          </article>
          {noticia?.read_time && (
            <article className="seccion-vistas-noticias seccion-redes-card">
              <BookmarkBorderIcon id="icon-redes-noticias" />
              {noticia?.read_time} min lectura
            </article>
          )}
        </CardContent>
        {/* </CardActionArea> */}
      </Card>
    );
  };

  return loading ? (
    <SkeletonLoaderCardNews />
  ) : (
    <Card
      sx={{ marginBottom: 3 }}
      className={`${tensoblog ? "card_blog item_eh" : ""} ${
        tensoblogClass ? "tenso-News-card" : ""
      } item`}
    >
      <a
        href={!noticia.multimedia ? `/noticias/${formatUrl(title)}` : `/noticias-multimedia/${formatUrl(title)}`}
        className="redireccion"
      >
        <CardActionArea>
          {noticia.video ? (
            <article>
              <iframe
                srcDoc={`
                              <style>
                                  body, .full {
                                      width: 100%;
                                      height: 100%;
                                      margin: 0;
                                      position: absolute;
                                      display: flex;
                                      justify-content: center;
                                      object-fit: cover;
                                  }
                              </style>
                              <a
                                  href='${noticia.video}?autoplay=1'
                                  class='full'
                              >
                                  <img
                                      src='http://img.youtube.com/vi/${noticia.video?.replace(
                                        "https://www.youtube.com/embed/",
                                        ""
                                      )}/0.jpg'
                                      class='full'
                                  />
                                  <svg
                                      version='1.1'
                                      viewBox='0 0 68 48'
                                      width='68px'
                                      style='position: relative;'
                                  >
                                      <path d='M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z' fill='#f00'></path>
                                      <path d='M 45,24 27,14 27,34' fill='#fff'></path>
                                  </svg>
                              </a>
                          `}
                style={{
                  maxWidth: "640px",
                  width: "100%",
                  aspectRatio: "16/9"
                }}
                allow="autoplay *; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                frameBorder="0"
              ></iframe>
            </article>
          ) : (
            <CardMedia
              component="img"
              height="140"
              image={noticia.imageCover ? noticia.imageCover[0]?.url : ""}
              alt={noticia.imageCover ? noticia.imageCover[0]?.alt : noticia?.title}
              title={noticia?.title}
              className="homenews__img-card"
            />
          )}
          <CardContent className="pb-5 cards-style">
            <article className="texto-slider">
              <p>{noticia.category}</p>
            </article>
            <article className="title-card-noticia">
              <h3 dangerouslySetInnerHTML={{ __html: titleSearch ? titleSearch : noticia.title }}></h3>
              {/* <span>{formatearFecha(noticia.creation_date)}</span> */}
            </article>
            <article>
              <p className="parrafo-noticias mt-2" dangerouslySetInnerHTML={{ __html: noticia.top }}></p>
            </article>
            {noticia?.read_time && !noticia.video && (
              <article className="seccion-vistas-noticias seccion-redes-card">
                <BookmarkBorderIcon id="icon-redes-noticias" />
                {noticia?.read_time} min lectura
              </article>
            )}
          </CardContent>
        </CardActionArea>
      </a>
    </Card>
  );
}

export default CardNews;
